<template>
  <div>
    <b-card>
      <div class="title">
        <p>查閱人手記錄</p>
      </div>
      <div class="d-flex align-items-center mb-2">
        <p class="mb-0 mr-4">
          戲院名稱 Theatre Name: <b>{{ theatreName }}</b>
        </p>
        <b-button
          size="sm"
          variant="outline-primary"
          @click="enterRecord"
        >
          輸入票房記錄
        </b-button>
      </div>

      <b-table
        bordered
        v-loading="loading"
        striped
        hover
        responsive
        :items="items"
        :fields="fields"
      >
        <template #cell(title_name)="data">
          <div style="width: 200px">
            {{ data.item.title_name }}
          </div>
        </template>
        <template #cell(show_time)="data">
          <div class="text-nowrap">
            {{ data.item.show_time }}
          </div>
        </template>
        <template #cell(date_of_engagement)="data">
          <div class="text-nowrap">
            {{ data.item.date_of_engagement }}
          </div>
        </template>
        <template #cell(total_admissions)="data">
          <div class="text-right">
            {{ data.item.total_admissions }}
          </div>
        </template>
        <template #cell(total_gross)="data">
          <div class="text-right">
            {{ data.item.total_gross }}
          </div>
        </template>
        <template #cell(action)="data">
          <b-button
            size="sm"
            variant="outline-primary"
            @click="editRecord(data.item.id)"
          >
            修訂記錄
          </b-button>
        </template>
      </b-table>

      <!-- Pagination + page-size selector -->
      <div
        v-if="total > 0"
        class="d-flex justify-content-between flex-wrap align-items-center"
      >
        <div class="d-flex align-items-center mb-0 mt-1">
          <span class="text-nowrap mr-1">
            Showing {{ rangeStart }} to {{ rangeEnd }} of {{ total }} entries
          </span>
          <b-form-select
            v-model="pageSize"
            :options="pageSizeOptions"
            class="mx-1"
            style="width: 80px"
            @input="onPageSizeChange"
          />
        </div>
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            first-number
            last-number
            align="right"
            class="mb-0 mt-1"
            prev-class="prev-item"
            next-class="next-item"
            @input="onPageChange"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { getTheatreManualHint } from '@/api/boxoffice.js'
import { BPagination, BFormSelect } from 'bootstrap-vue'

export default {
  components: {
    BPagination,
    BFormSelect,
  },
  data() {
    return {
      loading: false,
      theatreId: null,
      theatreName: '',
      items: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      pageSizeOptions: [10, 20, 30, 50],
      fields: [
        { key: 'id', label: 'E_ID', sortable: true},
        { key: 'title_name', label: 'Film Name', sortable: true },
        { key: 'film_id', label: 'Film ID', sortable: true },
        { key: 'date_of_engagement', label: 'Date Of Engagement', sortable: true },
        { key: 'show_time', label: 'Show Time', sortable: true },
        { key: 'house', label: 'House', sortable: true },
        { key: 'total_admissions', label: 'Total ADM.', sortable: true },
        { key: 'total_gross', label: 'Total B.O.', sortable: true },
        { key: 'src_type', label: 'Source', sortable: true },
        { key: 'updated_at', label: 'UpdateAt', sortable: true },
        { key: 'action', label: '' },
      ],
    }
  },
  computed: {
    rangeStart() {
      if (this.total === 0) return 0
      return (this.currentPage - 1) * this.pageSize + 1
    },
    rangeEnd() {
      return Math.min(this.currentPage * this.pageSize, this.total)
    },
  },
  methods: {
    fetchData() {
      this.loading = true
      const data = {
        theatre_id: this.theatreId,
        page: this.currentPage,
        page_size: this.pageSize,
      }
      getTheatreManualHint(data)
        .then((res) => {
          this.loading = false
          // res 已是 response body，res.data = 陣列, res.total = 總數
          this.items = res.data || []
          this.total = res.total || 0
        })
        .catch(() => {
          this.loading = false
          this.$message({
            message: '獲取數據失敗',
            type: 'error',
          })
        })
    },
    enterRecord() {
      this.$router.push({
        name: 'boxoffice_record_detail',
        query: {
          theatreid: this.theatreId,
          type: 'create',
          is_temp: 0,
        },
      })
    },
    editRecord(id) {
      this.$router.push({
        name: 'boxoffice_record_detail',
        query: {
          theatreid: this.theatreId,
          id,
          type: 'edit',
          prePage: 'handType',
        },
      })
    },
    onPageChange(page) {
      this.currentPage = page
      this.fetchData()
    },
    onPageSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.fetchData()
    },
  },
  created() {
    this.theatreId = this.$route.query.theatre_id
    this.theatreName = this.$route.query.theatre_name || ''
    if (this.theatreId) {
      this.fetchData()
    }
  },
}
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  border-bottom: 2px solid #0e72bc;
  color: #0e72bc;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 10px;
}
</style>
